export { FetchMock, defaultFetchMockConfig, } from './FetchMock.js';
import fetchMock from './FetchMock.js';
export default fetchMock;
